<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Avignonesi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Difficile da trovare, costoso e molto ricercato, Avignoesi ha apparentemente guadagnato la santissima trinità
                        di desiderabilità. Il loro obiettivo? Fare vini che riflettano la complessità e la bellezza del
                        territorio. Semplice, vero? Ehm; si, ma no.
                    </div>

                    <div class="howto-title2">Saverys il saggio</div>
                    <div class="howto-text">
                        Avignonesi nasce nel 1974 a Montepulchino, nel sud della Toscana. Sebbene negli anni '80 avesse goduto di una buona reputazione tra le sue controparti del Sangiovese, il vigneto stava lentamente ma costantemente perdendo denaro. Per fortuna, Virginie Saverys, un ricco avvocato (e amante del vino) si è ripreso
                        il salvataggio e ha acquistato la tenuta nel 2009. Saverys, cittadino belga, afferma che “il Sangiovese è
                        Toscana. Me ne sono innamorato per le sue tante, particolari caratteristiche”. Come
                        qualsiasi buona storia d'amore, questo non è stato facile; Saverys ha lottato con la burocrazia italiana ("è un
                        partner di ballo pesante"), in particolare nella sua decisione di consegnare l'intero vigneto a
                        agricoltura biodinamica. “Credo che con la biodinamica non solo siamo in grado di creare più sani
                        e vini più interessanti, ma stiamo anche promuovendo un ambiente più sano per il futuro”.
                        Così semplice eppure così eloquente, pensiamo che probabilmente abbia ragione.
                    </div>

                    <div class="howto-title2">Il segreto del successo di Avignonesi</div>
                    <div class="howto-text">
                        Avignonesi ora produce il loro famoso Sangiovese Occhio di Pernice Vin Santo di Montepulciano con
                        Tecniche biodinamiche al 100%, classificando il loro vino in qualità accanto a quelli prodotti nei vicini
                        Chianti Classico o Brunello di Montalcino. La casa produce più di 12 vini in totale,
                        comprese due deliziose Grappe. Il loro vasto repertorio offre un ottimo rapporto qualità-prezzo
                        (anche se tra i 400-600 € a bottiglia per l'Occhio di Perniche, dovremmo mettere in discussione il
                        uso della parola valore). Per le occasioni speciali assaggiate il Supertuscan Merlot, “Desiderio”, o
                        il Sangiovese e il Merlot “50&50” realizzati in collaborazione con Capannelle in Chianti. Purtroppo, il
                        la performance di mercato di Avignonesi è stata irregolare, quindi se vuoi davvero assaggiare un bicchiere o
                        due, il vigneto possiede due wine bar a Londra e uno ad Anversa.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Avignonesi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avignoesi ist schwer zu finden, teuer und sehr begehrt und scheint die heilige Dreifaltigkeit gewonnen zu haben
                        der Begehrlichkeit. Ihr Ziel? Weine herzustellen, die die Komplexität und Schönheit der Weine widerspiegeln
                        Terroir. Ganz einfach, oder? Ähm; Ja aber nein.
                    </div>

                    <div class="howto-title2">Saverys der Savious</div>
                    <div class="howto-text">
                        Avignonesi wurde 1974 in Montepulchino in der südlichen Toskana gegründet. Obwohl es in den 1980er Jahren bei seinen Sangiovese-Kollegen einen guten Ruf genossen hatte, verlor das Weingut langsam, aber stetig Geld. Zum Glück kam Virginie Saverys, eine wohlhabende Anwältin (und Weinliebhaberin), zu sich
                        Die Rettung und kaufte das Anwesen im Jahr 2009. Saverys, ein belgischer Staatsbürger, sagt: „Sangiovese ist
                        Toskana. Ich habe mich wegen seiner vielen besonderen Eigenschaften in ihn verliebt.“ Wie
                        jede gute Liebesbeziehung, das war nicht einfach; Saverys hatte mit der italienischen Bürokratie zu kämpfen („es ist eine …“)
                        schwerer Tanzpartner“), insbesondere in ihrer Entscheidung, den gesamten Weinberg zu übergeben
                        biodynamische Landwirtschaft. „Ich glaube, dass wir mit der Biodynamik nicht nur gesünder schaffen können
                        und interessantere Weine, aber wir fördern auch eine gesündere Umwelt für die Zukunft.“
                        So einfach und doch so eloquent, wir glauben, dass sie wahrscheinlich Recht hat.
                    </div>

                    <div class="howto-title2">Das Erfolgsgeheimnis von Avignonesi</div>
                    <div class="howto-text">
                        Avignonesi stellt jetzt seinen berühmten Sangiovese Occhio di Pernice mit Vin Santo di Montepulciano her
                        100 % biodynamische Techniken, die ihre Weine in ihrer Qualität mit denen aus benachbarten Regionen vergleichen
                        Chianti Classico oder Brunello di Montalcino. Das Haus stellt insgesamt mehr als 12 Weine her,
                        darunter zwei köstliche Grappas. Ihr umfangreiches Repertoire bietet ein sehr gutes Preis-Leistungs-Verhältnis
                        (obwohl wir bei einem Preis zwischen 400 und 600 € pro Flasche für den Occhio di Perniche das in Frage stellen müssten
                        Verwendung des Wortwerts). Probieren Sie zu besonderen Anlässen den Super-Tuscan Merlot „Desiderio“ oder
                        der Sangiovese und Merlot „50&50“, hergestellt in Zusammenarbeit mit Capannelle in Chianti. Leider ist das
                        Die Marktleistung von Avignonesi war unregelmäßig. Wenn Sie also wirklich ein Glas probieren möchten oder
                        Zweitens besitzt das Weingut zwei Weinbars in London und eine in Antwerpen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Avignonesi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Difficile à trouver, cher et très recherché, Avignoesi a apparemment gagné la sainte trinité
                        de désirabilité. Leur objectif? Elaborer des vins qui reflètent la complexité et la beauté des
                        terroir. Simple, non ? Euh; Oui mais non.
                    </div>

                    <div class="howto-title2">Saverys le savious</div>
                    <div class="howto-text">
                        Avignonesi a été fondée en 1974 à Montepulchino dans le sud de la Toscane. Bien qu'il jouissait d'une bonne réputation auprès de ses homologues du Sangiovese dans les années 1980, le vignoble perdait lentement mais régulièrement de l'argent. Heureusement, Virginie Saverys, une riche avocate (et amateur de vin) est venue
                        le sauvetage et a acheté le domaine en 2009. Saverys, un ressortissant belge, dit "Sangiovese est
                        Toscane. J'en suis tombé amoureux à cause de ses nombreuses caractéristiques particulières ». Comme
                        toute bonne histoire d'amour, ce n'était pas facile; Saverys a lutté avec la bureaucratie italienne ("c'est un
                        partenaire de danse lourde »), notamment dans sa décision de confier tout le vignoble à
                        agriculture biodynamique. "Je crois qu'avec la biodynamie, nous sommes non seulement capables de créer des
                        et des vins plus intéressants, mais nous promouvons aussi un environnement plus sain pour l'avenir ».
                        Si simple mais si éloquent, nous pensons qu'elle a probablement raison.
                    </div>

                    <div class="howto-title2">Le secret du succès d'Avignonesi</div>
                    <div class="howto-text">
                        Avignonesi élabore désormais son célèbre Sangiovese Occhio di Pernice Vin Santo di Montepulciano avec
                        Des techniques 100% biodynamiques, classant leur vin en qualité aux côtés de ceux élaborés dans les
                        Chianti Classico ou Brunello di Montalcino. La maison produit plus de 12 vins au total,
                        dont deux délicieuses grappas. Leur vaste répertoire offre un très bon rapport qualité/prix
                        (même si entre 400 et 600 € la bouteille pour l'Occhio di Perniche, il faudrait s'interroger sur la
                        utilisation du mot valeur). Pour les occasions spéciales, dégustez le Super-Toscan Merlot, « Desiderio », ou
                        le Sangiovese et Merlot « 50&50 » réalisé en collaboration avec Capannelle in Chianti. Malheureusement, le
                        la performance du marché d'Avignonesi a été erratique, donc si vous voulez vraiment goûter un verre ou
                        deux, le vignoble possède deux bars à vin à Londres et un à Anvers.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Avignonesi</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Hard to find, expensive and highly sought after, Avignoesi has seemingly gained the holy trinity
                        of desirability. Their goal? To make wines which reflect the complexity and beauty of the
                        terroir. Simple, right? Erm; yes, but no.
                    </div>

                    <div class="howto-title2">Saverys the savious</div>
                    <div class="howto-text">
                        Avignonesi was founded in 1974 in Montepulchino in southern Tuscany. Although it had enjoyed a good reputation among its Sangiovese counterparts in the 1980s, the vineyard was slowly but steadily losing money. Thankfully, Virginie Saverys, a wealthy lawyer (and wine lover) came to
                        the rescue and bought the estate in 2009. Saverys, a Belgian national, says “Sangiovese is
                        Tuscany. I have fallen in love with it because of its many, particular characteristics”. Like
                        any good love affair, this was not easy; Saverys struggled with Italian bureaucracy (“it’s a
                        heavy dance partner”), particularly in her decision to turn the entire vineyard over to
                        biodynamic farming. “I believe that with biodynamics we are not only able to create healthier
                        and more interesting wines, but we are also promoting a healthier environment for the future”.
                        So simple yet so eloquent, we think she is probably right.
                    </div>

                    <div class="howto-title2">The secret to Avignonesi success</div>
                    <div class="howto-text">
                        Avignonesi now makes their famous Sangiovese Occhio di Pernice Vin Santo di Montepulciano with
                        100% biodynamic techniques, ranking their wine in quality alongside those made in neighbouring
                        Chianti Classico or Brunello di Montalcino. The house makes more than 12 wines in total,
                        including two delicious Grappas. Their vast repertoire offers some very good value for money
                        (although at between €400-600 a bottle for the Occhio di Perniche, we would have to question the
                        use of the word value). For special occasions, taste the Super-Tuscan Merlot, “Desiderio”, or
                        the Sangiovese and Merlot “50&50” made in collaboration with Capannelle in Chianti. Sadly, the
                        market performance of Avignonesi has been erratic, so if you really want to sample a glass or
                        two, the vineyard owns two wine bars in London and one in Antwerp.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Avignonesi",
    head: {
        title: 'Avignonesi | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich heritage and exceptional quality of Avignonesi wine producer, a renowned name in the Tuscany wine region. Savor the unique blend of tradition and innovation in every sip of Avignonesi\'s premium wines, crafted with the finest grapes grown in the heart of Tuscany. Experience the essence of Tuscany with Avignonesi.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
